import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { showLoader, hideLoader } from "store/misc/loaderSlice";
import { showMessage } from "store/misc/messageSlice";
import { updateTaxRates } from "store/vino/checkoutSlice";
import { compliantStatusTypes } from "utils";
import shippingComplianceService from "services/shippingComplianceService";

export const checkCompliance = createAsyncThunk(
	"vino/shippingCompliance/check",
	async (checkoutId, { dispatch, rejectWithValue }) => {
		try {
			dispatch(showLoader());
			const response = await shippingComplianceService.check(checkoutId);
			if (response.statusCode === 200) {
				const {
					salesOrder: { salesTaxRates, complianceStatus },
				} = response;
				if (complianceStatus === compliantStatusTypes.COMPLIANT) {
					dispatch(updateTaxRates(salesTaxRates));
				}
			}
			return response;
		} catch (err) {
			console.error(err);
			dispatch(
				showMessage({
					message: "Error occurred while checking shipping compliance",
					variant: "error",
				})
			);
			return rejectWithValue(err.response.data);
		} finally {
			dispatch(hideLoader());
		}
	}
);

const initialState = {
	data: {},
	isCompliant: false,
	isComplianceChecked: false,
};

const shippingCompliance = createSlice({
	name: "vino/shippingCompliance",
	initialState,
	reducers: {
		resetShippingCompliance: () => initialState,
	},
	extraReducers: {
		[checkCompliance.fulfilled]: (state, action) => {
			const { statusCode, salesOrder, errors } = action.payload;
			if (statusCode === 200) {
				state.data = salesOrder;
				state.isCompliant =
					salesOrder.complianceStatus === compliantStatusTypes.COMPLIANT;
			} else {
				state.isCompliant = false;
				state.errors = errors;
			}
			state.isComplianceChecked = true;
		},
	},
});

export const { resetShippingCompliance } = shippingCompliance.actions;

export default shippingCompliance.reducer;
